export default __webpack_public_path__ + "static/media/quantstamp.b3ff0c9c.svg";